import * as ACTION_TYPES from '../constants/ACTION_TYPES';

const defaultState: CatalogState = {
  query: '',
  errorKey: null,
  isSearching: false,
  isUserSearch: false,
  isFilterShopItems: false,
  isFilterShopItemCategories: false,
  isFilterDataItems: false,
  focusedDataItemId: 0,
  focusedShopItemId: 0,
};

export const getLastSearchQuery = (state: CatalogState) => state.query;

export const isFilterShopItems = (state: CatalogState) =>
  state.isFilterShopItems;

export const isFilterDataItems = (state: CatalogState) =>
  state.isFilterDataItems;

export const isFilterShopItemCategories = (state: CatalogState) =>
  state.isFilterShopItemCategories;

export const isSearchingCatalog = (state: CatalogState) => state.isSearching;

export const getFocusedDataItemId = (state: CatalogState) =>
  state.focusedDataItemId;

export const getFocusedShopItemId = (state: CatalogState) =>
  state.focusedShopItemId;

export const isUserSearch = (state: CatalogState) => state.isUserSearch;

function handleReceivedCatalogSearchResults(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    isSearching: false,
  };
}

function handleBeginCatalogSearch(
  state: CatalogState,
  action: BeginCatalogSearchAction
): CatalogState {
  return {
    ...state,
    isSearching: true,
    query: action.payload.query,
  };
}

function handleSearchCatalogError(
  state: CatalogState,
  action: CatalogSearchErrorAction
): CatalogState {
  return {
    ...state,
    isSearching: false,
    errorKey: action.payload.message,
  };
}

function handleToggleFilterShopItems(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    isFilterShopItems: !state.isFilterShopItems,
  };
}

function handleToggleFilterDataItems(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    isFilterDataItems: !state.isFilterDataItems,
  };
}

function handleToggleFilterShopItemCategories(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    isFilterShopItemCategories: !state.isFilterShopItemCategories,
  };
}

function handleAddToFavourite(
  state: CatalogState,
  action: {
    payload: {
      data_items: DataItem[];
      shop_items: ShopItem[];
      updateFocusedItem: boolean;
    };
  }
): CatalogState {
  const payload = action.payload;
  if (!payload.updateFocusedItem) {
    return state;
  }
  const { data_items = [], shop_items = [] } = payload;
  return {
    ...state,
    focusedDataItemId: data_items.length && data_items[0].id,
    focusedShopItemId: shop_items.length && shop_items[0].id,
  };
}

function handleCatalogResetSelection(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    focusedDataItemId: 0,
    focusedShopItemId: 0,
  };
}

function handleSetUserInitiatedSearch(
  state: CatalogState,
  action: Action
): CatalogState {
  return {
    ...state,
    isUserSearch: action.payload,
  };
}

export default function catalog(
  state: CatalogState = defaultState,
  action: Action
): CatalogState {
  switch (action.type) {
    case ACTION_TYPES.CATALOG_BEGIN_SEARCH:
      return handleBeginCatalogSearch(
        state,
        action as BeginCatalogSearchAction
      );
    case ACTION_TYPES.CATALOG_RECEIVED_SEARCH_RESULTS:
      return handleReceivedCatalogSearchResults(state, action);
    case ACTION_TYPES.CATALOG_SEARCH_ERROR:
      return handleSearchCatalogError(
        state,
        action as CatalogSearchErrorAction
      );
    case ACTION_TYPES.CATALOG_FILTER_SHOP_ITEM:
      return handleToggleFilterShopItems(state, action);
    case ACTION_TYPES.CATALOG_FILTER_DATA_ITEM:
      return handleToggleFilterDataItems(state, action);
    case ACTION_TYPES.CATALOG_FILTER_SHOP_ITEM_CATEGORY:
      return handleToggleFilterShopItemCategories(state, action);
    case ACTION_TYPES.FAVOURITE_ADD_TO:
      return handleAddToFavourite(state, action as any);
    case ACTION_TYPES.CATALOG_RESET_FOCUS:
      return handleCatalogResetSelection(state, action);
    case ACTION_TYPES.CATALOG_USER_INITIATE_SEARCH:
      return handleSetUserInitiatedSearch(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/catalog.ts